import styled from 'styled-components';

export const ScProvidersSelect = styled.div`
  position: relative;
  width: 100%;

  .close {
    background-color: #000;
    filter: invert(1);
    border-radius: 50%;
    z-index: 12;
  }
`;
